import { CommonModule } from '@angular/common'
import { Component, inject } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { ConfirmationModalService } from '@services/confirmation-modal.service'

@Component({
  selector: 'mh-confirmation-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.scss',
})
export class ConfirmationModalComponent {
  private modalService = inject(ConfirmationModalService)

  isOpen = this.modalService.getIsOpen
  config = this.modalService.getModalConfig
  inputValue = this.modalService.getInputValue

  onConfirm(): void {
    const config = this.config()
    if (config?.showInput && !this.inputValue().trim()) {
      return
    }
    this.modalService.close(true)
  }

  onCancel(): void {
    this.modalService.close(false)
  }

  onBackdropClick(): void {
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      this.onCancel()
    } else if (event.key === 'Enter' && !(event.target as HTMLElement).classList.contains('modal-input')) {
      this.onConfirm()
    }
  }

  onInputChange(value: string): void {
    this.modalService.setInputValue(value)
  }

  onInputKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.onConfirm()
    }
  }
}
